import clsx from "clsx";
import { useLocale } from "hooks";
import { useState, useRef, useEffect, FC } from "react";

interface IProps {
  question: string;
  answer: string | JSX.Element | JSX.Element[];
  onToggle: () => void;
  open: boolean;
}

const FaqItem: FC<IProps> = ({ question, answer, onToggle, open }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [_, setState] = useState<Boolean>(false);
  useEffect(() => {
    const onResize = () => setState((prev) => !prev);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const { isRTL } = useLocale();
  return (
    <div
      className={`tw-py-2 md:tw-py-3 xxxl:tw-py-[17.33px] tw-mb-4 last:tw-mb-0 tw-transition-all tw-duration-500`}
    >
      <style>
        {`
          h2 {
            font-size: inherit;
          }
        `}
      </style>
      <div
        className="tw-flex tw-justify-between tw-items-center tw-cursor-pointer"
        onClick={() => onToggle()}
      >
        <div className={clsx("tw-relative tw-flex")}>
          <span
            className={clsx(
              { "tw-self-end": !open, "tw-self-center": open },
              { "tw-ml-3": isRTL, "tw-mr-3": !isRTL }
            )}
          >
            {open ? (
              <svg
                // className={"tw-relative -tw-top-3"}
                width="14"
                height="2"
                viewBox="0 0 14 2"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8 2H0V0L8 -0.000244141L14 0V2H8Z" fill="#344456" />
              </svg>
            ) : (
              <svg
                // className={"tw-relative -tw-top-3"}
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 8.33337V14.3334H6V8.33337H0V6.33337H6V0.333374H8V6.33337H14V8.33337H8Z"
                  fill="#2E3A59"
                />
              </svg>
            )}
          </span>
          <h6
            className={`!tw-text-[14px] xxxl:!tw-text-[17.33px] tw-font-medium tw-transition-all`}
          >
            {question}
          </h6>
        </div>
      </div>
      <div
        style={{ height: open ? (ref.current?.clientHeight || 0) + 18 : 0 }}
        className={`tw-transition-all tw-delay-[0ms] tw-duration-500 tw-overflow-hidden tw-relative`}
      >
        <p
          className="tw-text-tiny md:tw-text-md tw-text-[#344456] tw-h-fit tw-pt-[18px]"
          ref={ref}
        >
          {answer}
        </p>
      </div>
    </div>
  );
};

export default FaqItem;
